import { render, staticRenderFns } from "./IntroudeceEditorP.vue?vue&type=template&id=46284982&scoped=true&"
import script from "./IntroudeceEditorP.vue?vue&type=script&lang=js&"
export * from "./IntroudeceEditorP.vue?vue&type=script&lang=js&"
import style0 from "./IntroudeceEditorP.vue?vue&type=style&index=0&id=46284982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46284982",
  null
  
)

export default component.exports